<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import RealEstateBrokerRecentCommissionRow from './RealEstateBrokerRecentCommissionRow.vue';

const props = defineProps({
  loading: { type: Boolean, default: false },
  rows: { type: Array, default: () => [] },
});
const emit = defineEmits(['open']);

const { t } = useI18n();
const expanded = ref(true);
const mobileTitle = computed(() =>
  props.rows.length
    ? t('REAL_ESTATE_BROKER_DASHBOARD.RECENT.TITLE_WITH_COUNT', {
        count: props.rows.length,
      })
    : t('REAL_ESTATE_BROKER_DASHBOARD.RECENT.TITLE')
);
</script>

<template>
  <section data-testid="broker-recent-list">
    <button
      type="button"
      class="flex w-full items-center gap-[5px] bg-white px-6 py-[11px] text-left shadow-[0_0_6px_0_rgba(0,0,0,0.02),0_2px_4px_0_rgba(0,0,0,0.08)] md:hidden"
      data-testid="broker-recent-mobile-toggle"
      :aria-expanded="expanded"
      aria-controls="broker-recent-mobile-content"
      @click="expanded = !expanded"
    >
      <span class="i-lucide-list size-5 text-[#01988C]" aria-hidden="true" />
      <span class="text-base font-bold text-[#464F53]">{{ mobileTitle }}</span>
    </button>
    <div
      v-show="expanded"
      id="broker-recent-mobile-content"
      class="md:hidden"
      data-testid="broker-recent-mobile-content"
    >
      <div v-if="loading" class="bg-white px-6 py-[22px]">
        <div
          v-for="item in 3"
          :key="item"
          class="mb-4 h-24 animate-pulse rounded bg-lais-bg-soft last:mb-0"
        />
      </div>
      <template v-else>
        <RealEstateBrokerRecentCommissionRow
          v-for="row in rows"
          :key="row.commission_split_id"
          :row="row"
          @open="emit('open', $event)"
        />
      </template>
    </div>
    <LaisCard
      class="hidden md:flex"
      density="flush"
      data-testid="broker-recent-desktop"
    >
      <template #header>
        <div class="flex items-center gap-2">
          <h2 class="text-base font-bold text-[#464F53]">
            {{ t('REAL_ESTATE_BROKER_DASHBOARD.RECENT.TITLE') }}
          </h2>
          <span
            class="rounded-full bg-[#EDF8F7] px-2 py-1 text-xs font-semibold text-[#01988C]"
          >
            {{ rows.length }}
          </span>
        </div>
      </template>
      <div v-if="loading" class="divide-y divide-lais-border-soft">
        <div v-for="item in 3" :key="item" class="grid grid-cols-4 gap-4 p-4">
          <span
            v-for="cell in 4"
            :key="cell"
            class="h-5 animate-pulse rounded bg-lais-bg-soft"
          />
        </div>
      </div>
      <template v-else>
        <RealEstateBrokerRecentCommissionRow
          v-for="row in rows"
          :key="row.commission_split_id"
          :row="row"
          @open="emit('open', $event)"
        />
      </template>
    </LaisCard>
  </section>
</template>
